import { Database, ref, set } from 'firebase/database';
import type { MailTemplateAttachment, MailTemplateDocument } from '@opanuj/shared/types';

export const normalizeMailTemplatePayload = (
  next: Partial<MailTemplateDocument>,
  current?: Partial<MailTemplateDocument> | null,
): { subject: string; html: string; attachments?: MailTemplateAttachment[] } => {
  const subject = next.subject ?? current?.subject ?? '';
  const html = next.html ?? current?.html ?? '';
  const attachments = Array.isArray(next.attachments)
    ? next.attachments
    : Array.isArray(current?.attachments)
      ? current.attachments
      : undefined;

  return {
    subject: String(subject ?? ''),
    html: String(html ?? ''),
    ...(attachments ? { attachments } : {}),
  };
};

export const mailTemplateUpdate = async (
  database: Database,
  template: Partial<MailTemplateDocument>,
): Promise<void> => {
  const id = template.id;
  if (!id) {
    throw new Error('Mail template id is required.');
  }

  const payload = normalizeMailTemplatePayload(template, null);
  await set(ref(database, `email_templates/${id}`), payload);
};
